module.exports = __webpack_public_path__ + "img/wl.5005c1ba.png";